import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import { ajax } from "jquery";

export default class ShippingController extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore(this.props.store);
    }

    onChange(type, country) {
        ajax({
            url: this.props.url,
            data: {
                type,
                country,
                _token: this.props.token,
            },
            method: "post",
            dataType: "json",
            success: (result) => {
                if (result.type === "success") {
                    this.store.load(result.basket);
                }
            },
        });
    }

    render() {
        const ShippingView = ComponentRegistry.get(this.props.view);
        const ShippingTypeView = ComponentRegistry.get(this.props.itemView);

        const types = Object.keys(this.props.types).map(type => <ShippingTypeView
          {...this.props.types[type]}
          type={type}
          value={this.props.value}
          price={this.props.pricing}
          onChange={country => this.onChange(type, country)}
          key={type}
        />);

        return (<ShippingView {...this.props}>{types}</ShippingView>);
    }
}

ShippingController.propTypes = {
    store: React.PropTypes.string,
    view: PropTypes.string.isRequired,
    itemView: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    value: PropTypes.shape({}),
    pricing: PropTypes.string,
    types: PropTypes.objectOf(PropTypes.shape({})),
};

ShippingController.defaultProps = {
    view: "BasketViewsShippingView",
    itemView: "BasketViewsShippingTypeView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Controllers/ShippingController.jsx